import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

/**
 * This function takes the desired shadow styles + the active
 * states of all of the shadows and combines them to create
 * the CSS properties to be spread onto our shadow element.
 *
 * We also take the offsets for each direction and factor these
 * into the background position that we return
 *
 * Because we can have multiple backgrounds on a single element,
 * combining styles like this allows us to not pollute the DOM
 * with elements that we don't need
 */
export function combineBackgroundStyles(_ref) {
  var _context;

  var shadowStyles = _ref.shadowStyles,
      _ref$offsets = _ref.offsets,
      offsets = _ref$offsets === void 0 ? {} : _ref$offsets,
      activeShadows = _ref.activeShadows;

  var _Object$keys$reduce = _reduceInstanceProperty(_context = _Object$keys(shadowStyles)).call(_context, function (acc, direction) {
    acc.sizes.push(shadowStyles[direction].size);
    acc.images.push(shadowStyles[direction].image);
    acc.positions.push(activeShadows[direction] ? shadowStyles[direction].position(offsets[direction]) : shadowStyles[direction].initialPosition);
    return acc;
  }, {
    sizes: [],
    positions: [],
    images: []
  }),
      sizes = _Object$keys$reduce.sizes,
      positions = _Object$keys$reduce.positions,
      images = _Object$keys$reduce.images;

  return {
    backgroundSize: sizes.join(', '),
    backgroundPosition: positions.join(', '),
    backgroundImage: images.join(', ')
  };
}